__turbopack_context__.v({
  "reviewsSection": "reviews-module__Ji-Vga__reviewsSection",
  "reviewsSwiper": "reviews-module__Ji-Vga__reviewsSwiper",
});
